function setupAddToCartButtons() {
  document.querySelectorAll('.product-form').forEach((el) => {
    // Check if this button has already been initialized
    if (el.dataset.initialized) return;

    // Mark as initialized
    el.dataset.initialized = "true";

    el.addEventListener('click', (event) => {
      if (window.location.pathname != '/cart') {
        event.preventDefault();
        const form = el.querySelector('form');
        const button = el.querySelector('button');
        const productID = form.querySelector('input[name="id"]').value;

        button.disabled = true;
        if(button.querySelector('span')) {
           button.querySelector('span').innerHTML = 'Adding...';
        }
        // button.querySelector('span').innerHTML = 'Adding...';

        const cartItemData = {
          quantity: 1,
          id: parseInt(productID)
        };

        const data = {
          items: [cartItemData]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
          }
        })
          .then((res) => res.json())
          .then((data) => {
            button.disabled = false;
            if(button.querySelector('span')) {
               button.querySelector('span').innerHTML = 'Add To Cart';
            }
            // button.querySelector('span').innerHTML = 'Add To Cart';

            // Explicitly open the cart drawer
            const cartIcon = document.querySelector('.cart-icon');
            if (cartIcon) {
              cartIcon.dispatchEvent(new Event('click', {bubbles: true}));
            }
          });
      }
    });
  });
}

// Initialize on page load
window.addEventListener('DOMContentLoaded', setupAddToCartButtons);

// Set up a mutation observer to watch for dynamically added elements
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'childList' && mutation.addedNodes.length) {
      // Check if any new product forms were added
      let shouldSetup = false;
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.classList?.contains('product-form') || node.querySelector?.('.product-form'))) {
          shouldSetup = true;
        }
      });

      if (shouldSetup) {
        setupAddToCartButtons();
      }
    }
  }
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});


// Cart recommendations
class ProductRecommendationsCart extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations-cart');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initializeSwiper()
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }

  initializeSwiper() {
    new Swiper('.swiper-container', {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 30,
      breakpoints: {
        300: {
          slidesPerView: 1.3,
           spaceBetween: 10,

        },
         400: {
          slidesPerView: 1.3,
          spaceBetween: 30,

        }
      }
    });
  }

}

customElements.define('product-recommendations-cart', ProductRecommendationsCart);